import cx from 'clsx';

import { InputOverrideClassNames } from '../textinput';
import { InputStyleProps } from '../types';

import passwordInputClasses from './PasswordInput.module.css';

export const PasswordInputOverrideClassNames = (props: InputStyleProps) => {
  const { size, error, variant } = props;
  const classes = InputOverrideClassNames(props);
  return {
    ...classes,
    innerInput: cx(passwordInputClasses.innerInput, {
      [passwordInputClasses.innerInputXs]: size === 'xs',
      [passwordInputClasses.innerInputSm]: size === 'sm',
      [passwordInputClasses.innerInputMd]: size === 'md',
      [passwordInputClasses.innerInputLg]: size === 'lg',
      [passwordInputClasses.innerInputXl]: size === 'xl',
      [passwordInputClasses.innerInputError]: !!error,
      [passwordInputClasses.innerInputFilled]: variant === 'filled'
    }),
    visibilityToggle: cx(passwordInputClasses.visibilityToggle, {
      [passwordInputClasses.visibilityToggleFocussed]: props.focussed
    })
  };
};
